import React, { Component } from 'react'
import { Link, Redirect, Route } from 'react-router-dom'

import menuData from '../../routes'
import Exception from '../../components/Exception'
import AuthLayout from '../../layouts/AuthLayout'
import BasicLayout from '../../layouts/BasicLayout'
import Login from '../../containers/login'
import ForgotPassword from '../../containers/login/forgotPassword'
import '../../index.css'
import _ from 'lodash'
import rightAuth from '../../components/_utils/userRights'
import { notification } from 'antd';

let user = localStorage.getItem('user') != 'undefined' ? JSON.parse(localStorage.getItem('user')) : null;

notification.config({
    duration: 2,
    placement: 'topRight'
})
const Exp = () => (
    <Exception
        type="404"
        desc={'You Seems lost !!'}
        linkElement={Link}
        redirect={'/dashboard'}
        backText={'Go To Homepage?'}
    />
)
const Exp403 = () => (
    <Exception
        type="403"
        desc={'Sorry You Don\'t have access to this area !!'}
        linkElement={Link}
        redirect={'/dashboard'}
        backText={'Go To Homepage?'}
    />
)

class BasicLayoutWrapper extends Component {
    render() {
        const { menuData, menuItemTitle, component, path } = this.props

        if (!user) {
            return <Redirect to="/login" />
        }

        return (
            <BasicLayout
                location={window.location}
                pageTitle={`${menuItemTitle} - T-Vision`}
                menuData={menuData}>
                {!!component ? <this.props.component /> : <Exp />}
            </BasicLayout>
        )
    }
}

class App extends Component {
    state = {
        token: localStorage.getItem('token'),
        user: user,
        rights: localStorage.getItem('rights') != 'undefined'
            ? JSON.parse(localStorage.getItem('rights'))
            : null
    }

    constructor(props) {
        super(props)
    }

    render() {
        const { user, token } = this.state

        return (
            <div>
                {
                    menuData.map((item, key) => {
                        return (
                            <div key={key}>
                                {
                                    item.component ?
                                        <Route
                                            exact
                                            path={item.path}
                                            key={item.path}
                                            render={(route, index) => {
                                                return (
                                                    <React.Fragment>
                                                        {
                                                            rightAuth.checkRights(item.rights) ?
                                                                <BasicLayoutWrapper
                                                                    key={index}
                                                                    component={item.component}
                                                                    path={item.path}
                                                                    user={user}
                                                                    token={token}
                                                                    menuData={menuData}
                                                                    menuItemTitle={item.title}
                                                                /> : <Route component={Exp} />
                                                        }
                                                    </React.Fragment>

                                                )
                                            }}
                                        />
                                        : null
                                }
                                {
                                    item.children ?
                                        item.children.map((subItem, key) => {
                                            return (
                                                <div key={subItem.path + '-' + key}>
                                                    {
                                                        subItem.component ?
                                                            <>
                                                                <Route
                                                                    exact
                                                                    path={subItem.path}
                                                                    key={subItem.path + '32-' + key}
                                                                    render={route => {
                                                                        return (
                                                                            <React.Fragment>
                                                                                {
                                                                                    rightAuth.checkRights(subItem.rights) ?
                                                                                        <BasicLayoutWrapper
                                                                                            component={subItem.component}
                                                                                            path={subItem.path}
                                                                                            user={user}
                                                                                            token={token}
                                                                                            menuData={menuData}
                                                                                            menuItemTitle={subItem.title}
                                                                                        /> : <Route component={Exp} />
                                                                                }
                                                                            </React.Fragment>

                                                                        )
                                                                    }}
                                                                />
                                                            </>
                                                            : <Route component={subItem.component} />
                                                    }
                                                    {
                                                        subItem.children ?
                                                            subItem.children.map((subChildItem, subChildKey) => {
                                                                return (
                                                                    <div key={subChildItem.path}>
                                                                        {
                                                                            subChildItem.component ?
                                                                                <Route
                                                                                    exact
                                                                                    path={subChildItem.path}
                                                                                    key={subChildItem.path}
                                                                                    render={route => {
                                                                                        return (
                                                                                            <React.Fragment>
                                                                                                {
                                                                                                    rightAuth.checkRights(subChildItem.rights) ?
                                                                                                        <BasicLayoutWrapper
                                                                                                            component={subChildItem.component}
                                                                                                            path={subChildItem.path}
                                                                                                            user={user}
                                                                                                            token={token}
                                                                                                            menuData={menuData}
                                                                                                            menuItemTitle={subChildItem.title}
                                                                                                        /> : <Route component={Exp} />
                                                                                                }
                                                                                            </React.Fragment>

                                                                                        )
                                                                                    }}
                                                                                />
                                                                                : null
                                                                        }
                                                                    </div>
                                                                )

                                                            })
                                                            : null
                                                    }
                                                </div>
                                            )

                                        })
                                        : null
                                }
                            </div>
                        )
                    })
                }

                <Route
                    exact
                    path="/login"
                    render={route => {
                        return (
                            <AuthLayout location={window.location} menuData={menuData}>
                                <Login />
                            </AuthLayout>
                        )
                    }}
                />

                <Route
                    exact
                    path="/forgot-password"
                    render={route => {
                        return (
                            <AuthLayout>
                                <ForgotPassword />
                            </AuthLayout>
                        )
                    }}
                />

                <Route
                    exact
                    path="/"
                    render={route => {
                        return <Redirect to="/dashboard" />
                    }}
                />


                {/*<Route component={Exp}/>*/}


            </div>
        )
    }
}

export default App
